/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { BranchDto } from './branchDto.schema';

export const IReadOnlyListOfBranchDto = zod.array(zod.lazy(() => BranchDto));

export type IReadOnlyListOfBranchDto = zod.input<typeof IReadOnlyListOfBranchDto>;
export type IReadOnlyListOfBranchDtoOutput = zod.output<typeof IReadOnlyListOfBranchDto>;
